module.exports = __webpack_public_path__ + "media/images/Avento-a51f97fe237aea452b347c40b14e42be.png";